import SVG from './image.svg';

export default {
  SVG,
  name: 'u',
};
